<!-- <app-sidebar2 *ngIf="adminRole == 0"></app-sidebar2> -->
<app-sidebar3 [isOpen]="isSidebarOpen" (sideBarCollapseEmitter)="updateSideBarCollapse($event)"></app-sidebar3>
<div class="sidebar-overlay" [class.visible]="isSidebarOpen" (click)="onOverlayClick()"></div>

<div class="d-flex updated-main-header" style="width: 100%; ">
  <div class="headerLogoSection">
    <div class="sidebar-icon" (click)="toggleSideNavbar()">
      <span class="material-symbols-outlined">menu</span>
    </div>
    <div class="logo">
      <a (click)="redirectToHome()">
        <img height="85%" width="100%" src="../../../assets/images/Innova_logo.svg" alt="innova logo" />
      </a>
    </div>
    <!-- <div class="gsd-title" [ngStyle]="toggleSidebar.sidebarShow && {'border': '1px solid #96ABDB'}"
      (click)="openSidebar($event)">
      <div>Global Solutions <span class="delivery-text">Delivery</span></div>
      <span class="material-symbols-outlined icon_filp">
        {{toggleSidebar.sidebarShow ?
        'expand_less':'expand_more' }}
      </span>
    </div> -->
  </div>
  <div class="gsd-main-title">
    Global Solutions <span class="delivery-text">Delivery</span>
  </div>
  <div style="width: 10.4%; justify-content: end;" class="btn-group d-flex" (click)="dismissSidebar()">
    <div *ngIf="superAdmin" class="mr-4 align-self-center d-flex">
      <span class="material-symbols-outlined btn spin-btn menu-icon mr-4" [class.spin]="isAutoStarted"
        (click)="bulkUploadEmployees()" [matTooltip]="tipContent" matTooltipClass="tooltip-list">
        sync
      </span>
      <div class="btn menu-icon" [matMenuTriggerFor]="menu">
        <span class="material-symbols-outlined">
          settings
        </span>
      </div>
      <mat-menu class="emp-menu" #menu="matMenu">
        <button class="mat-menu" mat-menu-item (click)="bulkUploadNavigate()" type="button">
          Employee Data Import</button>
        <button class="mat-menu" mat-menu-item (click)="employeeDataNavigate()" type="button">
          Employee Data Export</button>
        <button class="mat-menu" mat-menu-item (click)="rolesNavigate()" type="button">
          Add&nbsp;Roles</button>
        <button class="mat-menu" mat-menu-item (click)="addPreferances()" type="button">
          Preferences</button>
        <button class="mat-menu" mat-menu-item (click)="ReminderAndEscalations()" type="button">
          Reminder and Escalations</button>
      </mat-menu>
    </div>
    <div *ngIf="userRole" class="mr-3 align-self-center d-flex">
      <button class="btn menu-icon" [matMenuTriggerFor]="notificationsMenu">
        <mat-icon [matBadge]="totalNotifications" matBadgeColor="primary" class="text-white"
          (click)="readclick()">notifications</mat-icon>
      </button>
    </div>
    <div
      style="position: relative; transform: translate3d(-7.357vw, 2.083vw, 0px); top: 0px; left: 0px; will-change: transform;">
      <mat-menu #notificationsMenu="matMenu" class="notifications-menu notifications-style">
        <div (click)="$event.stopPropagation()">
          <mat-card class="notifications-card" (scroll)="onScroll($event)">
            <mat-card-content>
              <h3 style="font-size:0.781vw;">Notifications</h3>
              <div class="notifications-content">

                <div style="width: 96%;" class="card m-1 p-2" *ngFor="let notification of notificationsData">


                  <h5 style="font-size: 10px; font-weight: 400;">{{notification.notificationMessage}}</h5>
                  <p
                    style="font-size:0.651vw; margin-left: auto; margin-top: auto; margin-bottom: 0px; font-weight: 400;">
                    <mat-icon class="unread" *ngIf="!notification.isRead">done</mat-icon>
                    <mat-icon class="read-icon" *ngIf="notification.isRead">done_all</mat-icon>
                    {{notification.createdDate | date:'dd MMM yy, hh:mm a' }}
                  </p>
                </div>

              </div>
              <div *ngIf="showViewMore" class="view-more" (click)="showMoreNotifications()"> View more </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-menu>
    </div>
    <div class="align-self-center d-flex" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="user">
      <div class="user d-flex">
        <div class="user-circle">
          {{getUserName(username)}}
        </div>
        <i class="fas fa-angle-down user-icon"></i>
      </div>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="user">
        <div class="align-self-center bodyCopy useremail" style="color: black">{{useremail}}</div>
        <button class="dropdown-item bodyCopy logout" style="cursor: pointer;" (click)="logout()" type="button"><i
            class="fas fa-sign-out-alt mr-1"></i>
          Logout</button>
      </div>
    </div>
  </div>
</div>